// Complete ROUTE_MAP for TR/EN/AZ locales
// All routes are defined per locale - no fallbacks

export const ROUTE_MAP = {
  tr: {
    home: '/',
    valveMaintenance: '/vana-bakim',
    products: '/urunler',
    services: '/hizmetler',
    solutions: '/cozumler',
    applications: '/uygulamalar',
    industries: '/sektorler',
    about: '/hakkimizda',
    faq: '/sss',
    contact: '/iletisim',
    docs: '/dokumantasyon',
    news: '/haberler',
    customerStories: '/musteri-hikayeleri',
    videos: '/videolar',
    energyTransition: '/enerji-donusumu',
    privacy: '/gizlilik-politikasi',
    cookies: '/cerez-politikasi'
  },
  en: {
    home: '/en',
    valveMaintenance: '/valve-maintenance',
    products: '/products',
    services: '/services',
    solutions: '/solutions',
    applications: '/applications',
    industries: '/industries',
    about: '/about',
    faq: '/faq',
    contact: '/contact',
    docs: '/documentation',
    news: '/news',
    customerStories: '/customer-stories',
    videos: '/videos',
    energyTransition: '/energy-transition',
    privacy: '/privacy-policy',
    cookies: '/cookie-policy'
  },
  az: {
    home: '/az',
    valveMaintenance: '/vana-baxim',
    products: '/mehsullar',
    services: '/xidmetler',
    solutions: '/heller',
    applications: '/tetbiqler',
    industries: '/senayeler',
    about: '/haqqimizda',
    faq: '/tss',
    contact: '/elaqe',
    docs: '/dokumentasiya',
    news: '/xeberler',
    customerStories: '/musteri-hekayeleri',
    videos: '/videolar-az',
    energyTransition: '/enerji-kecidi',
    privacy: '/mexfilik-siyaseti',
    cookies: '/cerez-siyaseti'
  }
};

export const NAV_LABELS = {
  tr: {
    home: 'Ana Sayfa',
    valveMaintenance: 'Vana Bakım',
    products: 'Ürünler',
    services: 'Hizmetler',
    solutions: 'Çözümler',
    applications: 'Uygulamalar',
    industries: 'Sektörler',
    about: 'Hakkımızda',
    faq: 'SSS',
    contact: 'İletişim',
    docs: 'Dokümantasyon',
    news: 'Haberler',
    customerStories: 'Başarı Hikayeleri',
    videos: 'Videolar',
    energyTransition: 'Enerji Dönüşümü',
    privacy: 'Gizlilik Politikası',
    cookies: 'Çerez Politikası'
  },
  en: {
    home: 'Home',
    valveMaintenance: 'Valve Maintenance',
    products: 'Products',
    services: 'Services',
    solutions: 'Solutions',
    applications: 'Applications',
    industries: 'Industries',
    about: 'About Us',
    faq: 'FAQ',
    contact: 'Contact',
    docs: 'Documentation',
    news: 'News',
    customerStories: 'Success Stories',
    videos: 'Videos',
    energyTransition: 'Energy Transition',
    privacy: 'Privacy Policy',
    cookies: 'Cookie Policy'
  },
  az: {
    home: 'Ana Səhifə',
    valveMaintenance: 'Vana Baxım',
    products: 'Məhsullar',
    services: 'Xidmətlər',
    solutions: 'Həllər',
    applications: 'Tətbiqlər',
    industries: 'Sənayelər',
    about: 'Haqqımızda',
    faq: 'TSS',
    contact: 'Əlaqə',
    docs: 'Dokumentasiya',
    news: 'Xəbərlər',
    customerStories: 'Uğur Hekayələri',
    videos: 'Videolar',
    energyTransition: 'Enerji Keçidi',
    privacy: 'Məxfilik Siyasəti',
    cookies: 'Çərəz Siyasəti'
  }
};

export const getNavigation = (locale) => {
  const routes = ROUTE_MAP[locale];
  const labels = NAV_LABELS[locale];
  if (!routes || !labels) return [];

  return [
    { key: 'home', name: labels.home, href: routes.home },
    { key: 'valveMaintenance', name: labels.valveMaintenance, href: routes.valveMaintenance },
    { key: 'products', name: labels.products, href: routes.products },
    { key: 'services', name: labels.services, href: routes.services },
    { key: 'solutions', name: labels.solutions, href: routes.solutions },
    { key: 'applications', name: labels.applications, href: routes.applications },
    { key: 'industries', name: labels.industries, href: routes.industries },
    { key: 'about', name: labels.about, href: routes.about },
    { key: 'faq', name: labels.faq, href: routes.faq },
    { key: 'contact', name: labels.contact, href: routes.contact }
  ];
};

export const getRoute = (locale, key) => {
  return ROUTE_MAP[locale]?.[key] || '/';
};

export const getLabel = (locale, key) => {
  return NAV_LABELS[locale]?.[key] || key;
};
